/*!
 * =====================================
 * 工具类方法
 */

import jsencrypt from "jsencrypt/bin/jsencrypt";

// import moment from 'moment'
var moment = require("moment");
const utils = {
    /**
     * 解析时间戳
     * @param {Object} timestamp 时间搓
     * @param {Object} onlyDate 日期 ： true 日期 + 时分秒 false
     */
    formatDate(timestamp, onlyDate) {
        timestamp = parseInt(timestamp);
        var times =
            timestamp.toString().length > 10 ? timestamp : timestamp * 1000;
        var date = new Date(times);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();

        if (onlyDate) {
            return (
                this.numberPrefix(4, year) +
                "-" +
                this.numberPrefix(2, month) +
                "-" +
                this.numberPrefix(2, day)
            );
        }

        return (
            this.numberPrefix(4, year) +
            "-" +
            this.numberPrefix(2, month) +
            "-" +
            this.numberPrefix(2, day) +
            " " +
            this.numberPrefix(2, hour) +
            ":" +
            this.numberPrefix(2, minute) +
            ":" +
            this.numberPrefix(2, second)
        );
    },

    /**
     *
     * @param {Object} size
     * @param {Object} num
     */
    numberPrefix(size, num) {
        var sLen = ("" + num).length;
        if (sLen >= size) {
            return "" + num;
        }
        var preZero = new Array(size).join("0");

        return preZero.substring(0, size - sLen) + num;
    },

    /**
     * 去空格
     * @param {*} str
     */
    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },

     

    /**
     * 设置cookie
     * @param {*} c_name
     * @param {*} value
     * @param {*} expiredays
     */
    setCookie(c_name, value, expiredays = 1) {
        const exDate = new Date();
        exDate.setDate(exDate.getDate() + expiredays);
        document.cookie =
            c_name +
            "=" +
            escape(value) +
            (expiredays == null ? "" : ";expires=" + exDate.toGMTString());
        //document.cookie = c_name + "=" + escape(value)
    },

    /**
     * 获取cookie
     * @param {*} name
     */
    getCookie(name) {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return arr[2];
        else return null;
    },

 
 

    //删除cookie
    removeCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie =
                name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    delCookie(name) {
        var date = new Date();
        date.setTime(date.getTime() - 10000);
        document.cookie =
            name + "=v; expire=" + date.toGMTString() + "; path=/";
    },
isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iphone|ipad|ipod/i.test(userAgent) || /blackberry/i.test(userAgent) || /playbook/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      return true; // 移动端
    }
    return false; // PC端
  },
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },

    //base64 util.Base64().encode(str)
    //base64 util.Base64().dencode(str)
 
    /**
     * 判断是否为空对象
     * @param {*} obj
     */
    isEmptyObject(obj) {
        var name;
        for (name in obj) {
            return false;
        }
        return true;
    },

    /**guid */
    guid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
            c
        ) {
            var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
    GetGuid() {
        //生成部分退款，唯一标识
        var html = moment(new Date()).format("YYYYMMDDhhmmssS"); 
        for (var i = 0; i < 4; i++) {
            html += Math.floor(Math.random() * 10);
        }
        return html;
    }, 
    time(date, type,splicingText) {
        if (date) {
            date = new Date(date);
        } else {
            date = new Date();
        }
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        var second = date.getSeconds();
        second = second < 10 ? "0" + second : second;
        let txt = "";
        if (type == "ymd") {//获取当前时间 
            txt = y + "-" + m + "-" + d + " " + "00:00:00";
        } else if(type == "splicing"){
            //当前时间拼接
            txt = y + "-" + m + "-" + d + " " + splicingText;
        }
        else{
             txt = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
        }
        return txt;
    },
	/**
	 *设置时效缓存
	 *key:存储得key值
	 * value:存储得value值
	 * time 有效时间，不填则默认一小时
	**/
	setSessionStorageWithExpiry(key,value,time){ 
		const now=new Date();
		//设置过期时间（毫秒）
		time=time||1; 
		const  expiry=time*3600000; 
		  const item={
			value:value,
			  expiry:now.getTime()+expiry,
		  };
		  sessionStorage.setItem(key,JSON.stringify(item));
		  
	},
	/**
	 * 获取带有有效期数据
**/
	getssionStorageWithExpiry(key){ 
		const itemStr=sessionStorage.getItem(key)||""; 
		if(itemStr=="") return null;
		const item=JSON.parse(itemStr); 
		const now=new Date();
		console.log("now",now.getTime());
		//如果数据已过期，则清除并返回null
        if(now.getTime()>item.expiry){
			sessionStorage.removeItem(key);
			return null;
		}
		return item.value;
	}
	
};

var obj = {
    install(Vue) {
        Vue.prototype.utils = utils;
    }
};

export { obj as default, utils };
